import React from 'react';
import { ExclamationTriangleFill } from 'react-bootstrap-icons';
import Alert from 'react-bootstrap/Alert';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

type Props = {
    content: string;
    title?: string;
};

export const Warning: React.FC<Props> = Props => {
    const { content, title } = Props;

    return (
        <Alert className="justify-content-between" variant="warning">
            <Row>
                <Col xs="auto" md="auto">
                    <ExclamationTriangleFill size={60} />
                </Col>
                <Col>
                    <Alert.Heading>{title || 'Let op!'}</Alert.Heading>
                    <p>{content}</p>
                </Col>
            </Row>
        </Alert>
    );
};
